import type { XYPosition } from '@xyflow/react';
import type { EditorNode } from '../../domain/editor-graph';
import { getNodeDefinition } from '../registry/node-registry';

export function createNodeFromDefinition(type: string, position: XYPosition): EditorNode {
  const definition = getNodeDefinition(type);
  if (!definition) throw new Error(`Unknown node type: ${type}`);
  return {
    id: crypto.randomUUID(),
    type: definition.type,
    position,
    data: structuredClone(definition.defaultData),
    locked: false,
    draggable: true,
    selectable: true,
    ...(definition.type === 'group-frame' ? { width: 360, height: 220, zIndex: -1 } : {}),
  };
}
